module.exports = __webpack_public_path__ + "static/media/img1-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/FE/img1-1.png
// module id = 1213
// module chunks = 3